export const MIN_CHANNEL_BUDGET = 50;
export const ROUNDING_TOLERANCE = 1;
export const MIN_JOB_DESCRIPTION_LENGTH = 250;
export const VONQ_CONTRACT_MIN_DURATION = 7;
export const ZIPRECRUITER_BUDGET_PRESETS = [
  { label: '$149', value: 149 },
  { label: '$299', value: 299 },
];
